import React, { useCallback } from 'react';
import {
  TabContainer,
  TabButton,
} from '../styles/PackageIndexStyles';

const SearchTabs = ({ activeTab, setActiveTab }) => {
  const selectTab = useCallback((value) => setActiveTab(value), [setActiveTab]);

  return (
    <>
      <TabContainer>
        <TabButton
          $active={activeTab === 'Methods'}
          onClick={() => selectTab('Methods')}
          aria-label="Show Methods"
        >
          Methods
        </TabButton>

        <TabButton
          $active={activeTab === 'Bags'}
          onClick={() => selectTab('Bags')}
          aria-label="Show Labels"
        >
          Labels
        </TabButton>

        <TabButton
          $active={activeTab === 'PLU'}
          onClick={() => selectTab('PLU')}
          aria-label="Show PLU"
        >
          PLU
        </TabButton>

        <TabButton
          $active={activeTab === 'UPC'}
          onClick={() => selectTab('UPC')}
          aria-label="Show UPC"
        >
          UPC
        </TabButton>

        <TabButton
          $active={activeTab === 'Displays'}
          onClick={() => selectTab('Displays')}
          aria-label="Show Displays"
        >
          Displays
        </TabButton>
      </TabContainer>
    </>
  );
};

export default React.memo(SearchTabs);
